import { MapPin, X } from 'lucide-react'
import { useSiteFilterStore } from '../../store/siteFilterStore.js'
import { useSites } from '../../hooks/useData.js'
import { useLanguage } from '../../i18n/index.jsx'

// Minimal shape read from the loose useSites() hook return.
interface SiteRow { id: number | string; name?: string | null }

export default function SiteFilterBanner() {
  const { siteIds, clearFilter } = useSiteFilterStore()
  const { data: sites = [] } = useSites() as { data?: SiteRow[] }
  const { t } = useLanguage()

  if (!siteIds.length) return null

  const names = siteIds
    .map(id => sites.find(s => String(s.id) === String(id))?.name)
    .filter(Boolean)

  if (!names.length) return null

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 8,
      padding: '6px 16px', fontSize: 'var(--text-sm)', fontWeight: 600,
      background: 'var(--accent-dim, rgba(6,182,212,0.08))',
      borderBottom: '1px solid var(--border-subtle)',
      color: 'var(--accent)',
    }}>
      <MapPin size={13} />
      <span>{t('showing')}: {names.join(', ')}</span>
      <button
        onClick={clearFilter}
        title={t('clearFilter')}
        style={{
          marginLeft: 'auto', background: 'none', border: 'none',
          color: 'var(--text-muted)', cursor: 'pointer', padding: 2,
          borderRadius: 4, display: 'flex', alignItems: 'center',
        }}
      >
        <X size={14} />
      </button>
    </div>
  )
}
